<template>
    <div class="page-start">
        <div class="cover"></div>
        <div class="container" v-if="isShowLanguage">
            <div class="wrapper">
                <div class="box">
                    <div class="logo">
                        <img src="@/assets/logo-square.png" alt="Professional be Positive" title="Professional be Positive" />
                    </div>
                    <div class="language">
                        <h1>Language</h1>
                        <button @click="selectLang('th')">
                            <img src="@/assets/flag-th.png" alt="ProbPlus - ภาษาไทย" title="ProbPlus - ภาษาไทย" />
                            <span>ภาษาไทย</span>
                        </button>
                        <button @click="selectLang('en')">
                            <img src="@/assets/flag-en.png" alt="ProbPlus - English" title="ProbPlus - English" />
                            <span>English</span>
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    components: {
    },
    data() {
        return {
            isShowLanguage: false
        }
    },
    created() {
        let page = this;
        
        setTimeout(function(){
            page.checkDefaultLang();
        }, this.$WeConfig.TimeLoader);
    },
    methods: {
        checkDefaultLang() {
            let langCode = this.$cookie.get('defaultLang');
            
            if (langCode) {
                this.redirectUrl(langCode);
            }
            else {
                this.isShowLanguage = true;
            }
        },
        selectLang(langCode) {
            this.redirectUrl(langCode); 
        },
        redirectUrl(langCode) {
            this.$WeHelper.modalLoad();
            this.$cookie.set('defaultLang', langCode, { expires: '1Y' });

            let website = location.origin;
            location.href = website + '/' + langCode;
        }
    }
}
</script>

<style lang="scss">
@import '@/weact/scss/Variables.scss';

.page-start {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 0;
    background: url('../assets/bg-startup.jpg') #f7f7f7 center center no-repeat;
    background-size: cover;
    
    .cover {
        position: fixed;
        top: 0;
        left: 0;
        right: 0;
        bottom: 0;
        z-index: 0;
        background: rgba(0, 0, 0, 0.8);
    }

    .container {
        position: relative;
        z-index: 1;
        height: 100%;
    }

    .wrapper {
        display: flex;
        align-items: center;
        justify-content: center;
        width: 100%;
        height: 100%;

        .box {
            width: 100%;
            max-width: 270px;

            .logo {
                margin-bottom: 40px;

                img {
                    display: block;
                    width: 130px;
                    margin: auto;
                }
            }

            .language {
                background: #fff;
                margin: 20px 0;

                h1 {
                    font-weight: bold;
                    font-size: 15px;
                    margin: 0;
                    padding: 15px 10px;
                    text-align: center;
                    background: #eee;
                    border-bottom: 1px solid #bbb;
                }

                button {
                    position: relative;
                    width: 100%;
                    height: 60px;
                    border: none;
                    border-bottom: 1px solid #ddd;
                    background: none;
                    outline: none;
                    @include transition(none);

                    &:last-child {
                        border-bottom: none;
                    }

                    &:hover {
                        background: #ccc;
                    }

                    img {
                        position: absolute;
                        top: 20px;
                        display: block;
                        left: 15px;
                        width: 30px;
                    }

                    span {
                        display: block;
                        font-size: 14px;
                    }
                }
            }
        }
    }
}
</style>